import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

import { reportError } from '@/lib/monitoring/report';

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  window.addEventListener('error', (event) => {
    void reportError(event.error ?? event.message, {
      runtime: 'browser',
      url: window.location.href,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    void reportError(event.reason, {
      runtime: 'browser',
      url: window.location.href,
      tags: { kind: 'unhandledrejection' },
    });
  });
}

// Web Vitals: LCP / INP / CLS / FCP / TTFB. Шлём отдельным beacon'ом на
// /api/vitals — оттуда летит в structured logger (для Grafana/Loki). GlitchTip
// для них не годится, он про ошибки, не про perf-метрики.
//
// `sendBeacon` гарантирует доставку даже при page-unload; fetch keepalive —
// fallback для Safari, где Beacon не всегда отрабатывает на iframes.
function sendVital(metric: Metric) {
  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    id: metric.id,
    rating: metric.rating,
    navigationType: metric.navigationType,
    delta: metric.delta,
  });
  const url = '/api/vitals';
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) return;
    }
    void fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    });
  } catch {
    // Метрика — не критика, молча игнорируем.
  }
}

onLCP(sendVital);
onINP(sendVital);
onCLS(sendVital);
onFCP(sendVital);
onTTFB(sendVital);
